import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { LightGreySidely, SurfaceColor } from '../../styles/global/css/Utils';

export type SwitchValue<T = unknown> = {
	value: T,
	img: JSX.Element,
	to?: string,
	onClick?: (value: T) => void
}

export const SwapImageContainer = styled.div<{ selected: boolean, imageSize?: string }>`
	height: ${p => p.imageSize ?? '22px'};
	width: ${p => p.imageSize ?? '22px'};
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 3px;
	cursor: pointer;
	transition: background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;
	border-radius: 25px;

	${p => p.selected
		? `
		background-color: ${SurfaceColor};
		box-shadow: 0px 1px 2px lightgrey;
		`
		: `
		opacity: 33%;
		background-color: transparent;
	`}
`;

export const IconsGroupBackground = styled.div<{ background?: boolean, backgroundHeight?: string }>`
		display: flex;
		gap: 4px;
		border-radius: 25px;
		${({ background }) => background ? `background-color: ${LightGreySidely};` : ''}
		height : ${p => p.backgroundHeight ?? '28px'};
		align-items: center;
		padding: 0 2px;
		width: fit-content;
`;

export default function PageSwitch<T = unknown>(props: { selectedValue?: T, list: SwitchValue<T>[], background?: boolean, imageSize?: string, backgroundHeight?: string, singleButton?: boolean }) {
	const { list, selectedValue } = props;

	return <IconsGroupBackground background={props.background} backgroundHeight={props.backgroundHeight}>
		{list.map((v, i) => {
			const handleClick = () => {
				if (list.length === 2 && selectedValue === v.value) {
					const otherElement = list.find(item => item.value !== v.value);
					otherElement?.onClick?.(otherElement.value);
				} else {
					v.onClick?.(v.value);
				}
			};
			const selected = (selectedValue !== undefined && selectedValue === v.value) || (!v.onClick && !v.to);
			const inner = <SwapImageContainer key={`swapImage[${i}]`} selected={selected} imageSize={props.imageSize} onClick={handleClick}>
				{React.cloneElement(v.img, {
					size: props.imageSize,
				})}
			</SwapImageContainer>;
			if (v.to) return <NavLink key={`swapImage[${i}]`} to={v.to}>{inner}</NavLink>;
			return inner;
		})}
	</IconsGroupBackground>;
}
